import React from 'react';
import { Location } from 'react-router-dom';
import ModalRouteRedirect from './ModalRouteRedirect';
import ModalOverlayEntry from './ModalOverlayEntry';

interface ModalOverlayRouteProps {
    fallbackBackground: Pick<Location, 'pathname'> & Partial<Pick<Location, 'search' | 'hash'>>;
    children: React.ReactNode;
}

/** Direct-URL / refresh recovery: restore a frozen background page, then render the modal. */
const ModalOverlayRoute: React.FC<ModalOverlayRouteProps> = ({ fallbackBackground, children }) => (
    <ModalRouteRedirect fallbackBackground={fallbackBackground}>
        <ModalOverlayEntry>{children}</ModalOverlayEntry>
    </ModalRouteRedirect>
);

export default ModalOverlayRoute;
